import React from "react";
import styles from "./machine-structure-panel-control-bar.module.scss";
import { VerticalSeparator } from "@src/components/atoms/vertical-separator/vertical-separator";
import { ControlBarCreateFolderButton } from "@src/components/atoms/control-bar-create-folder-button/control-bar-create-folder-button";
import { ControlBarRenameFolderButton } from "@src/components/atoms/control-bar-rename-folder-button/control-bar-rename-folder-button";
import { ControlBarDeleteButton } from "@src/components/atoms/control-bar-delete-node-button/control-bar-delete-node-button";
import { ControlBarBulkModifyDataAcquisitionTypeButton } from "@src/components/atoms/control-bar-bulk-modify-data-acquisition-type-button/control-bar-bulk-modify-data-acquisition-type-button";
import { ControlBarDashboardSetupButton } from "@src/components/atoms/control-bar-dashboard-setup-button/control-bar-dashboard-setup-button";
import { FilterIcon } from "@src/components/molecules/filter-icon/filter-icon";
import { useFilterIconNewMachineStructureHook } from "@src/components/molecules/filter-icon/use-filter-icon-new-machine-structure-hook";
import { useMachineStructurePanelControlBarHook } from "./use-machine-structure-panel-control-bar-hook";
import { NodesCounterSelector } from "../nodes-counter-selector/nodes-counter-selector";
import { RenderIfUserHasPermission } from "../render-if-user-has-permission/render-if-user-has-permission";

const cssClassName = "machine-structure-panel-control-bar";

export const MachineStructurePanelControlBar = () => {
  const { unassignedBlueprintNodeDataFiltered } =
    useMachineStructurePanelControlBarHook();

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__buttons-wrapper`]}>
        {!unassignedBlueprintNodeDataFiltered && (
          <FilterIcon useHook={useFilterIconNewMachineStructureHook} />
        )}
        <div
          className={styles[`${cssClassName}__button-central-inner-wrapper`]}
        >
          <ControlBarCreateFolderButton />
          <ControlBarRenameFolderButton />
          <ControlBarDeleteButton />
          <VerticalSeparator />
          <ControlBarBulkModifyDataAcquisitionTypeButton />
          <RenderIfUserHasPermission permission={"manage-blueprint-dashboards"}>
            <ControlBarDashboardSetupButton />
          </RenderIfUserHasPermission>
        </div>
        <div className={styles[`${cssClassName}__button-right-inner-wrapper`]}>
          {/* TODO: activate this feature */}
          {/* <IconButton fun={() => ({})} icon={blueprintPlusBlueIcon} /> */}
        </div>
      </div>
      <NodesCounterSelector structure="machine" />
    </div>
  );
};
